export const chat = {
  copyMessage: "Copiar mensaje",
  reprompt: "Volver a preguntar", // Or "Repreguntar"
  placeholder: "Escribí tu mensaje...",
  loadMoreMessages: "Cargar más mensajes",
  editSystemPrompt: "Editar prompt del sistema",
  messageCopied: "Mensaje copiado",
  dashboard: {
    title: "Panel de Control", // Or just "Panel"
  },
  chat: {
    title: "Chat",
  },
  modelSelect: {
    modelHelpText: "Seleccionar modelo",
    providerHelpText: "Seleccionar proveedor",
  },
  slides: {
    helpText: "Configurar generación de diapositivas",
    numSlides: "Número de diapositivas",
    template: "Plantilla de diapositivas",
  },
  types: {
    basic: "Chat Básico",
    multiChat: "Chat Comparativo",
    generationChat: "Chat de Generación de IA",
    imageGeneration: "Generación de Imágenes",
    videoGeneration: "Generación de Video",
    presentation: "Presentación de Diapositivas",
    buuAgent: "Chat con Agente Buu Digital",
    agent: "Agente",
    character: "Personaje",
    dataMining: "Minería de Datos",
    audioGeneration: "Generación de Audio",
    musicGeneration: "Generación de Música",
  },
  memory: {
    helpText: "Definir memoria",
    prompt: "Definir memoria (0-1000):",
  },
  modelInfo: {
    all: "Todos",
    close: "Cerrar",
    loadMore: "Cargar más",
    filterByCapability: "Filtrar por capacidad",
    filterByProvider: "Filtrar por proveedor",
    showDisabled: "Mostrar deshabilitados",
    free: "Gratis",
    disabled: "Deshabilitado",
    helpText: "Información de modelos y servicios de IA",
    title: "Precios de Servicios Integrados",
    description: "Descripción del modelo",
    capabilities: "Capacidades",
    inputCost: "Costo de entrada por 1M tokens:",
    outputCost: "Costo de salida por 1M tokens:",
    costPerGeneration: "Costo por evento:",
    sortByCost: "Ordenar por costo",
    costLowToHigh: "Costo: Menor a Mayor",
    costHighToLow: "Costo: Mayor a Menor",
    notice:
      "Algunos modelos pueden tener restricciones regionales según las políticas de los proveedores. Los modelos gratuitos tienen límites diarios de uso.",
    pricing: {
      perMillion: "por 1M tokens",
    },
    toolCalling: "Herramientas",
    reasoning: "Razonamiento",
    vision: "Visión",
    embedding: "Embedding",
    image: "Imagen",
    video: "Video",
    chat: "Chat",
    music: "Música",
    multimodal: "Multimodal",
    textToSpeech: "Texto a Voz",
    reranking: "Reranking", // "Reranking" can be kept as is, or translated as "Reclasificación"
    dataMining: "Minería de Datos",
  },
  imageSettings: {
    helpText: "Configuraciones de imagen",
    title: "Configuraciones de imagen",
    modelSearch: "Buscar modelos de CivitAI",
    viewModelOnCivitai: "Ver modelo en CivitAI",
    selectedRunwareModel: "Modelo seleccionado de CivitAI",
    negativePromptToggle: "Mostrar prompt negativo",
    negativePrompt: "Prompt negativo",
    negativePromptHelpText:
      "Un prompt negativo es una frase o palabras que describen lo que el modelo debe evitar. Por ejemplo, si querés una imagen de un perro, no querés una imagen de un gato, entonces el prompt negativo sería 'gato'.",
    negativePromptPlaceholder: "Ingresá el prompt negativo...",
    hd: "HD",
    size: "Tamaño",
    sizeHelpText:
      "Ajustá las dimensiones de la imagen generada especificando su ancho y alto en píxeles, o seleccioná a partir de las opciones predefinidas. Las dimensiones de la imagen deben ser múltiplos de 64 (ejemplo: 512x512, 1024x768).",
    format: "Formato",
    numImages: "Cantidad de imágenes",
    numImagesHelpText:
      "Especificá cuántas imágenes querés generar en una sola solicitud. Cada generación de imagen se cobrará por separado.",
    width: "Ancho",
    height: "Alto",
    steps: "Pasos",
    stepsHelpText:
      "Los pasos son las iteraciones que un modelo realiza para generar una imagen. El número de pasos determina la calidad y detalle de la imagen, pero también aumenta el tiempo/costo para generar la imagen.",
    cfgScale: "Escala CFG", // Keeping "CFG Scale" as "Escala CFG" is common
    cfgScaleHelpText:
      "Ajusta qué tan cerca la imagen generada se alinea con el prompt de entrada. Un valor mayor fuerza una mayor fidelidad al prompt, mientras que un valor menor permite más libertad creativa.",
    scheduler: "Planificador", //  "Scheduler" can be translated as "Planificador" or "Programador"
    schedulerHelpText:
      "Seleccioná el planificador para la generación de la imagen. Diferentes planificadores influencian cómo el modelo se aproxima a refinar la imagen, afectando el estilo y la calidad.",
    seed: "Semilla", // "Seed" is often translated as "Semilla"
    seedHelpText:
      "Un número aleatorio usado para inicializar el proceso de generación de imagen, para tener resultados consistentes/similares, definí la misma semilla para el mismo prompt.",
    strength: "Fuerza",
    strengthHelpText: "Fuerza para la generación de la imagen",
    advancedControls: "Controles avanzados",
    decorType: "Tipo de decoración",
    decorTypeHelpText:
      "Seleccioná Prime para acabados de pared, Stage para decoración de interiores",
    uploadImage: "Cargar imagen",
    uploadReferenceImage: "Cargar imagen de referencia",
    imageUrl: "URL de la imagen",
    dragAndDrop: "Arrastrá y soltá para agregar la imagen",
    roomType: "Tipo de habitación",
    roomTypes: {
      livingroom: "Sala de estar",
      kitchen: "Cocina",
      diningroom: "Comedor",
      bedroom: "Dormitorio",
      bathroom: "Baño",
      kidsroom: "Habitación infantil",
      familyroom: "Sala familiar", // or "Estar"
      readingnook: "Rincón de lectura",
      sunroom: "Jardín de invierno", // Or "Terraza acristalada"
      walkincloset: "Vestidor",
      mudroom: "Recibidor", // Or "Guardarropa"
      toyroom: "Sala de juegos",
      office: "Oficina", // or "Despacho"
      foyer: "Vestíbulo", // Or "Recibidor"
      powderroom: "Toilette", // Or "Aseo"
      laundryroom: "Lavadero",
      gym: "Gimnasio",
      basement: "Sótano",
      garage: "Garage", // "Garage" is commonly used in Argentina.
      balcony: "Balcón",
      cafe: "Cafetería",
      homebar: "Bar en casa",
      study_room: "Sala de estudio",
      front_porch: "Porche delantero",
      back_porch: "Porche trasero",
      back_patio: "Patio trasero",
    },
    designStyle: "Estilo de diseño",
    designStyles: {
      minimalist: "Minimalista",
      scandinavian: "Escandinavo",
      industrial: "Industrial",
      boho: "Boho", // "Boho" is commonly used.
      traditional: "Tradicional",
      artdeco: "Art Deco", // "Art Deco" is commonly used.
      midcenturymodern: "Moderno de mediados de siglo",
      coastal: "Costero",
      tropical: "Tropical",
      eclectic: "Ecléctico",
      contemporary: "Contemporáneo",
      frenchcountry: "Campestre francés",
      rustic: "Rústico",
      shabbychic: "Shabby Chic", // "Shabby Chic" is commonly used.
      vintage: "Vintage", // "Vintage" is commonly used.
      country: "Campestre", // "Country" as "Campestre"
      modern: "Moderno",
      asian_zen: "Zen Asiático",
      hollywoodregency: "Hollywood Regency", // "Hollywood Regency" is commonly used.
      bauhaus: "Bauhaus", // "Bauhaus" is commonly used.
      mediterranean: "Mediterráneo",
      farmhouse: "Estilo granja", // Or "Casa de campo"
      victorian: "Victoriano",
      gothic: "Gótico",
      moroccan: "Marroquí",
      southwestern: "Suroeste", // "Suroeste" (referring to a style)
      transitional: "Transicional",
      maximalist: "Maximalista",
      arabic: "Árabe",
      japandi: "Japandi", // "Japandi" is commonly used.
      retrofuturism: "Retro futurismo",
      artnouveau: "Art Nouveau", // "Art Nouveau" is commonly used.
    },
    colorScheme: "Esquema de colores",
    specialityDecor: "Decoración especial",
    scaleFactor: "Factor de escala",
    colorSchemes: {
      colorScheme0: "Predeterminado",
      colorScheme1: "Verde musgo, Beige, Blanco",
      colorScheme2: "Gris, Arena, Azul",
      colorScheme3: "Verde cazador, Rojo",
      colorScheme4: "Blanco, Toques de color",
      colorScheme5: "Azul, Neón",
      colorScheme6: "Azul claro, Esmeralda",
      colorScheme7: "Azul, Verde césped",
      colorScheme8: "Azul, Beige",
      colorScheme9: "Gris, Marrón",
      colorScheme10: "Negro, Rojo",
      colorScheme11: "Verde grisáceo, Blanco, Negro",
      colorScheme12: "Azul, Gris, Topo", // "Taupe" is often translated as "Topo"
      colorScheme13: "Negro, Azul",
      colorScheme14: "Esmeralda, Beige",
      colorScheme15: "Verde bosque, Gris claro",
      colorScheme16: "Amarillo, Gris",
      colorScheme17: "Rosa, Verde",
      colorScheme18: "Rosa claro, Negro",
      colorScheme19: "Negro, Blanco",
      colorScheme20: "Azul, Blanco",
    },
    specialityDecors: {
      specialityDecor0: "Ninguna",
      specialityDecor1:
        "Decoración de Halloween con ambiente espeluznante, elementos aterradores, colores oscuros y acentos festivos",
      specialityDecor2:
        "Decoración navideña con árbol de Navidad, adornos y luces",
      specialityDecor3: "Decoración de Acción de Gracias, Decoración de otoño",
      specialityDecor4: "Decoración de otoño",
      specialityDecor5: "Decoración de primavera",
      specialityDecor6: "Decoración de verano",
      specialityDecor7: "Decoración de invierno",
    },
  },
  newSession: "Nueva", // "Nueva Sesión"
  newChat: "Nuevo Chat",
  temperature: {
    helpText: "Definir temperatura",
    prompt: "Definir temperatura (0-2):",
  },
  you: "Vos",
  ai: "IA",
  system: "Sistema",
  deleteMessage: "Eliminar mensaje",
  systemMessageUpdated: "Prompt del sistema actualizado correctamente",
  deleteSession: "Eliminar sesión",
  renameSession: "Renombrar sesión",
  sessionNamePlaceholder: "Ingresá el nombre de la sesión...",
  sendMessage: "Enviar mensaje",
  expand: "Expandir entrada",
  collapse: "Contraer entrada",
  credits: {
    view: "Ver Detalles de Uso",
    balance: "Créditos: ${{amount}}",
  },
  numChats: {
    select: "Seleccioná la cantidad de chats que querés tener en esta sesión",
    reset: "Resetear",
    warning:
      "Al cambiar la cantidad de columnas, el chat comparativo se reseteará, TODOS LOS MENSAJES SE PERDERÁN, ¿estás seguro?",
  },
  errors: {
    creditsExceeded:
      "Excediste tu límite de créditos.  Por favor, actualizá tu suscripción o agregá créditos para continuar usando el servicio.",
    generic:
      "Ocurrió un error al generar la respuesta.  Por favor, intentá nuevamente.",
    failed: "Error al enviar el mensaje",
  },
  agentChat: {
    changeAgent: "Cambiar Agente",
  },
};
